module.exports = __webpack_public_path__ + "static/media/024.01787886.jpg";